module.exports = __webpack_public_path__ + "img/value4.13b53a18.png";